import React from 'react'
import { Button } from '@/components/button'
import LanguageName from '@/components/LanguageName'

class RowItem extends React.Component {
  getTitle = (language) => (this.props.title || {})[language]
  getLanguageCss = (language) => `lang-${language}`
  renderDownloadButtons () {
    const { localize, file, download } = this.props
    if (file === null) { return null }

    const buttons = []
    Object.keys(file).forEach((lang, index) => {
      const fileAttachment = file[lang]
      if (fileAttachment.verified === true) {
        buttons.push(
          <div className='row-title' key={index}>
            <Button color='link' onClick={() => download(fileAttachment)} icon='download'><LanguageName localize={localize} locale={lang} /></Button>
          </div>
        )
      } else {
        buttons.push(
          <div className='row-title' key={index}>
            <Button disabled key={index} title={localize('Common.UnvailableForDownload')}><LanguageName localize={localize} locale={lang} /></Button>
          </div>
        )
      }
    })
    if (buttons.length > 0) {
      return <div className='rst__lang-row'>{buttons}</div>
    }
    return null
  }
  render () {
    const { locale } = this.props
    return (
      <React.Fragment>
        <div>
          {this.props.type === 'chapter' ? (<i className='bx bx-folder' />) : (<i className='bx bx-file-blank' />)}
          <div className='rst__lang-row'>
            <div className={`row-title ${this.getLanguageCss(locale)}`}>{this.getTitle(locale)}</div>
          </div>
          {this.renderDownloadButtons()}
        </div>
      </React.Fragment>
    )
  }
}

export default RowItem



// WEBPACK FOOTER //
// ./src/components/documentationViewer/dataSource/item.js